(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ee-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.productsToShow = parseInt(this.dataset.productsToShow || 4);
      this.productGrid = this.querySelector('.product-grid');
      this.placeholder = this.querySelector('.recently-viewed-products__placeholder');
      
      this.handleIntersection = this.handleIntersection.bind(this);
      new IntersectionObserver(this.handleIntersection, {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
    
    handleIntersection(entries) {
      if (!entries[0].isIntersecting) return;
      
      this.renderRecentlyViewedProducts();
    }
    
    // Helper function to get title from URL
    getTitleFromUrl(url) {
      if (!url) return '';
      
      // Extract the last part of the URL path
      const pathParts = url.split('/');
      let handle = pathParts[pathParts.length - 1];
      
      // Remove any query parameters
      handle = handle.split('?')[0];
      
      // Convert handle to title case
      return handle
        .replace(/-/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
    }
    
    renderRecentlyViewedProducts() {
      let recentlyViewed = [];
      try {
        const storedData = localStorage.getItem('recentlyViewed');
        if (storedData) {
          recentlyViewed = JSON.parse(storedData);
        }
      } catch (e) {
        recentlyViewed = [];
      }
      
      // Get products excluding the current one if we're on a product page
      let productsToRender = recentlyViewed;
      if (typeof meta !== 'undefined' && meta.product) {
        productsToRender = recentlyViewed.filter(item => item.id !== meta.product.id);
      }
      
      // Limit to configured number of products
      productsToRender = productsToRender.slice(0, this.productsToShow);
      
      if (productsToRender.length === 0) {
        this.productGrid.style.display = 'none';
        this.placeholder.style.display = 'block';
        return;
      }
      
      this.placeholder.style.display = 'none';
      
      // Clear existing items
      this.productGrid.innerHTML = '';
      
      // Get image ratio from data attribute
      const imageRatio = this.getAttribute('data-image-ratio') || 'adapt';
      
      // Add products to the grid
      productsToRender.forEach((product, index) => {
        // Extract and format title
        let productTitle = 'Product';
        
        // Force string conversion and trim
        if (product.title && product.title.trim() !== '') {
          productTitle = String(product.title).trim();
        } else if (product.url) {
          // Extract title from URL
          productTitle = this.getTitleFromUrl(product.url);
          
          // Update the product title in localStorage for next time
          product.title = productTitle;
          this.updateProductInStorage(product);
        } else if (product.handle) {
          productTitle = product.handle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        }
        
        const productUrl = product.url || `/products/${product.handle}`;
        const productImage = product.image || '';
        const formattedPrice = this.formatMoney(product.price);
        
        // Format product weight display
        let weightHtml = '';
        if (product.weight && typeof product.weight === 'string' && product.weight.trim() !== '') {
          weightHtml = `<div class="product-weight"><b>${product.weight}</b></div>`;
        }
        
        const productElement = document.createElement('li');
        productElement.classList.add('grid__item');
        
        productElement.innerHTML = `
          <div class="recently-viewed-card product-card-wrapper underline-links-hover">
            <a href="${productUrl}" class="full-unstyled-link">
              <div class="card-rv-02 card--${imageRatio}">
                <div class="rv-card__inner">
                  <div class="rv-card__media">
                    <div class="rv-media rv-media--transparent media--hover-effect">
                      ${productImage ? `
                        <img
                          src="${productImage}"
                          alt="${productTitle}"
                          class="motion-reduce"
                          loading="lazy"
                          width="269"
                          height="254"
                        >
                      ` : `
                        <div class="card__media--placeholder">
                          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-placeholder" fill="none" viewBox="0 0 18 14" aria-hidden="true">
                            <path d="M1 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1Zm1.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm13.993 9.657H1.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h14.993a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5Zm0-3.5H5.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h9.993a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5Z" fill="currentColor"/>
                          </svg>
                        </div>
                      `}
                    </div>
                  </div>
                  <div class="rv-card__content">
                    <div class="card__information rv-card-information">
                      <h3 class="card__heading h5">
                        <span class="full-unstyled-link">${productTitle}</span>
                      </h3>
                      <div class="rv-card-information">
                        ${weightHtml}
                        <div class="rv-card-price">
                          <div class="rv-card-price__regular">
                            <span class="visually-hidden">Regular price</span>
                            <span class="rv-card-price-item rv-card-price-item--regular">${formattedPrice} <span class="currency-code">USD</span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        `;
        
        this.productGrid.appendChild(productElement);
      });
      
      this.classList.add('recently-viewed-products--loaded');
    }
    
    // Update a product in localStorage
    updateProductInStorage(product) {
      try {
        const storedData = localStorage.getItem('recentlyViewed');
        if (!storedData) return;
        
        const products = JSON.parse(storedData);
        const index = products.findIndex(item => item.id === product.id);
        
        if (index !== -1) {
          products[index] = { ...products[index], ...product };
          localStorage.setItem('recentlyViewed', JSON.stringify(products));
        }
      } catch (e) {
        // Error handling
      }
    }
    
    formatMoney(cents) {
      if (typeof cents !== 'number') {
        cents = parseFloat(cents) || 0;
      }
      
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      
      // Fallback price formatting
      const value = (cents / 100).toFixed(2);
      return `$${value}`;
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-recipe"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
